import { useTranslation } from 'react-i18next';

export function useLocalizedData(data) {
    const { i18n } = useTranslation();
    const langCode = i18n.language;

    /**
     * Универсальный метод для получения переведенных данных
     * @param {string} key - ключ данных (например 'banner', 'aboutHome')
     * @param {boolean} returnArray - возвращать ли массив (по умолчанию false)
     * @returns {any} - переведенные данные или fallback
     */
    const getLocalized = (key, returnArray = false) => {
        if (!data || !key) return returnArray ? [] : '';

        // Определяем префикс для языка
        let langPrefix = '';
        if (langCode === 'ru') langPrefix = 'ru_';
        if (langCode === 'hy') langPrefix = 'arm_';

        // Пытаемся получить локализованные данные
        const localizedKey = `${langPrefix}${key}`;
        const localizedData = data[localizedKey];

        // Возвращаем данные в зависимости от типа
        if (returnArray) {
            return Array.isArray(localizedData) ? localizedData :
                Array.isArray(data[key]) ? data[key] : [];
        }

        return localizedData !== undefined ? localizedData :
            data[key] !== undefined ? data[key] : '';
    };

    /**
     * Специальный метод для получения первого элемента массива (например для баннеров)
     * @param {string} key - ключ данных
     * @returns {object} - первый элемент массива или пустой объект
     */
    const getLocalizedFirstItem = (key) => {
        const arrayData = getLocalized(key, true);
        return arrayData.length > 0 ? arrayData[0] : {};
    };
    const getLocalizedArray = (key) => {
        const arrayData = getLocalized(key, true);
        return Array.isArray(arrayData) ? arrayData : [];
    };

    return {
        getLocalized,
        getLocalizedFirstItem,
        getLocalizedArray,
        currentLanguage: langCode
    };
}